// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"122":"6c479972","453":"ec46dd5b","478":"c42543c9","479":"f8e99f6d","523":"00919313","630":"2ca58e16"}[chunkId] + ".chunk.js";
};